import { View } from "@-/com.npmjs.react-native";
import type { ReactNode } from "react";
import { NATIVE_MENU_CORNER_RADIUS } from "#native-menu-corner-radius";
import { useCappedCornerRadius } from "#use-capped-corner-radius";

/** Menu rows inside the menu's `p-1`, clipped concentric with the glass's corners. */
export function MenuGlassRowsClip({ children }: { children: ReactNode }) {
  const corners = useCappedCornerRadius(NATIVE_MENU_CORNER_RADIUS - 4);
  return (
    <View
      className="overflow-hidden"
      onLayout={corners.onLayout}
      style={{ borderRadius: corners.borderRadius }}
    >
      {children}
    </View>
  );
}
